import React, { memo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, oneOf, string } from 'prop-types'

const VARIANT_WRAPPER_CLASS = {
  subscription: 'usage-modal__card-footer',
  upgrade: 'usage-modal__upgrade-card-actions',
}

// Subscription CTA row (primary button + "Learn more" link) shared by the 3D Studio usage modal
// and the AI subscription landing waitlist modal. The hrefs are injected so the component does not
// depend on the studio store/hook.
function CardFooter({
  variant,
  ctaLabel = 'Get Subscription',
  subscriptionHref,
  learnMoreHref = '#',
  onClose: handleClose,
}) {
  return (
    <div className={VARIANT_WRAPPER_CLASS[variant]}>
      <Button
        size="small"
        type="primary"
        href={subscriptionHref}
        onClick={handleClose}
      >
        {ctaLabel}
      </Button>
      {/* Learn more link hidden until it points to a real destination (TODO_LEARN_MORE_HREF is '#')
      <a
        className="cgt-body-base-semibold cgt-link-primary"
        href={learnMoreHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn more
      </a>
      */}
    </div>
  )
}

CardFooter.propTypes = {
  variant: oneOf(['subscription', 'upgrade']).isRequired,
  ctaLabel: string,
  subscriptionHref: string.isRequired,
  learnMoreHref: string,
  onClose: func.isRequired,
}

export default memo(CardFooter)
